/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CreatedOrCompletedBy,
    CreatedOrCompletedByFromJSON,
    CreatedOrCompletedByFromJSONTyped,
    CreatedOrCompletedByToJSON,
    Expenses,
    ExpensesFromJSON,
    ExpensesFromJSONTyped,
    ExpensesToJSON,
    NotificationReceivers,
    NotificationReceiversFromJSON,
    NotificationReceiversFromJSONTyped,
    NotificationReceiversToJSON,
    TaskType,
    TaskTypeFromJSON,
    TaskTypeFromJSONTyped,
    TaskTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReadOnlyMaintenanceTask
 */
export interface ReadOnlyMaintenanceTask {
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMaintenanceTask
     */
    readonly id?: string;
    /**
     * 
     * @type {TaskType}
     * @memberof ReadOnlyMaintenanceTask
     */
    taskType?: TaskType;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMaintenanceTask
     */
    monitoredObject?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMaintenanceTask
     */
    user?: number | null;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyMaintenanceTask
     */
    place?: object;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMaintenanceTask
     */
    contact?: string;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMaintenanceTask
     */
    dueMileageKilometers?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyMaintenanceTask
     */
    dueDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMaintenanceTask
     */
    repetitionDueDateType?: ReadOnlyMaintenanceTaskRepetitionDueDateTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMaintenanceTask
     */
    repetitionDueDateValue?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyMaintenanceTask
     */
    repetitionBindToDueDate?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMaintenanceTask
     */
    repetitionDueMileageKilometers?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMaintenanceTask
     */
    notificationDueDateDays?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMaintenanceTask
     */
    notificationDueMileageKilometers?: number | null;
    /**
     * 
     * @type {Array<NotificationReceivers>}
     * @memberof ReadOnlyMaintenanceTask
     */
    notificationRecievers?: Array<NotificationReceivers> | null;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyMaintenanceTask
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyMaintenanceTask
     */
    updatedAt?: Date;
    /**
     * 
     * @type {CreatedOrCompletedBy}
     * @memberof ReadOnlyMaintenanceTask
     */
    createdBy?: CreatedOrCompletedBy;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyMaintenanceTask
     */
    completionTime?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMaintenanceTask
     */
    completionMileageKilometers?: number | null;
    /**
     * 
     * @type {CreatedOrCompletedBy}
     * @memberof ReadOnlyMaintenanceTask
     */
    completedBy?: CreatedOrCompletedBy;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMaintenanceTask
     */
    readonly deleted?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMaintenanceTask
     */
    state?: ReadOnlyMaintenanceTaskStateEnum;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMaintenanceTask
     */
    readonly dueDateLeftSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMaintenanceTask
     */
    readonly dueMileageLeftKilometers?: number;
    /**
     * 
     * @type {Expenses}
     * @memberof ReadOnlyMaintenanceTask
     */
    expenses?: Expenses;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMaintenanceTask
     */
    lastEvaluationMileage?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyMaintenanceTask
     */
    lastEvaluationTimestamp?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMaintenanceTask
     */
    notes?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMaintenanceTask
     */
    client?: number | null;
}

export function ReadOnlyMaintenanceTaskFromJSON(json: any): ReadOnlyMaintenanceTask {
    return ReadOnlyMaintenanceTaskFromJSONTyped(json, false);
}

export function ReadOnlyMaintenanceTaskFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyMaintenanceTask {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'taskType': !exists(json, 'task_type') ? undefined : TaskTypeFromJSON(json['task_type']),
        'monitoredObject': !exists(json, 'monitored_object') ? undefined : json['monitored_object'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'place': !exists(json, 'place') ? undefined : json['place'],
        'contact': !exists(json, 'contact') ? undefined : json['contact'],
        'dueMileageKilometers': !exists(json, 'due_mileage_kilometers') ? undefined : json['due_mileage_kilometers'],
        'dueDate': !exists(json, 'due_date') ? undefined : (json['due_date'] === null ? null : new Date(json['due_date'])),
        'repetitionDueDateType': !exists(json, 'repetition_due_date_type') ? undefined : json['repetition_due_date_type'],
        'repetitionDueDateValue': !exists(json, 'repetition_due_date_value') ? undefined : json['repetition_due_date_value'],
        'repetitionBindToDueDate': !exists(json, 'repetition_bind_to_due_date') ? undefined : json['repetition_bind_to_due_date'],
        'repetitionDueMileageKilometers': !exists(json, 'repetition_due_mileage_kilometers') ? undefined : json['repetition_due_mileage_kilometers'],
        'notificationDueDateDays': !exists(json, 'notification_due_date_days') ? undefined : json['notification_due_date_days'],
        'notificationDueMileageKilometers': !exists(json, 'notification_due_mileage_kilometers') ? undefined : json['notification_due_mileage_kilometers'],
        'notificationRecievers': !exists(json, 'notification_recievers') ? undefined : (json['notification_recievers'] === null ? null : (json['notification_recievers'] as Array<any>).map(NotificationReceiversFromJSON)),
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updatedAt': !exists(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'createdBy': !exists(json, 'created_by') ? undefined : CreatedOrCompletedByFromJSON(json['created_by']),
        'completionTime': !exists(json, 'completion_time') ? undefined : (json['completion_time'] === null ? null : new Date(json['completion_time'])),
        'completionMileageKilometers': !exists(json, 'completion_mileage_kilometers') ? undefined : json['completion_mileage_kilometers'],
        'completedBy': !exists(json, 'completed_by') ? undefined : CreatedOrCompletedByFromJSON(json['completed_by']),
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'dueDateLeftSeconds': !exists(json, 'due_date_left_seconds') ? undefined : json['due_date_left_seconds'],
        'dueMileageLeftKilometers': !exists(json, 'due_mileage_left_kilometers') ? undefined : json['due_mileage_left_kilometers'],
        'expenses': !exists(json, 'expenses') ? undefined : ExpensesFromJSON(json['expenses']),
        'lastEvaluationMileage': !exists(json, 'last_evaluation_mileage') ? undefined : json['last_evaluation_mileage'],
        'lastEvaluationTimestamp': !exists(json, 'last_evaluation_timestamp') ? undefined : (json['last_evaluation_timestamp'] === null ? null : new Date(json['last_evaluation_timestamp'])),
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'client': !exists(json, 'client') ? undefined : json['client'],
    };
}

export function ReadOnlyMaintenanceTaskToJSON(value?: ReadOnlyMaintenanceTask | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'task_type': TaskTypeToJSON(value.taskType),
        'monitored_object': value.monitoredObject,
        'user': value.user,
        'place': value.place,
        'contact': value.contact,
        'due_mileage_kilometers': value.dueMileageKilometers,
        'due_date': value.dueDate === undefined ? undefined : (value.dueDate === null ? null : value.dueDate.toISOString()),
        'repetition_due_date_type': value.repetitionDueDateType,
        'repetition_due_date_value': value.repetitionDueDateValue,
        'repetition_bind_to_due_date': value.repetitionBindToDueDate,
        'repetition_due_mileage_kilometers': value.repetitionDueMileageKilometers,
        'notification_due_date_days': value.notificationDueDateDays,
        'notification_due_mileage_kilometers': value.notificationDueMileageKilometers,
        'notification_recievers': value.notificationRecievers === undefined ? undefined : (value.notificationRecievers === null ? null : (value.notificationRecievers as Array<any>).map(NotificationReceiversToJSON)),
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'created_by': CreatedOrCompletedByToJSON(value.createdBy),
        'completion_time': value.completionTime === undefined ? undefined : (value.completionTime === null ? null : value.completionTime.toISOString()),
        'completion_mileage_kilometers': value.completionMileageKilometers,
        'completed_by': CreatedOrCompletedByToJSON(value.completedBy),
        'state': value.state,
        'expenses': ExpensesToJSON(value.expenses),
        'last_evaluation_mileage': value.lastEvaluationMileage,
        'last_evaluation_timestamp': value.lastEvaluationTimestamp === undefined ? undefined : (value.lastEvaluationTimestamp === null ? null : value.lastEvaluationTimestamp.toISOString()),
        'notes': value.notes,
        'client': value.client,
    };
}

/**
* @export
* @enum {string}
*/
export enum ReadOnlyMaintenanceTaskRepetitionDueDateTypeEnum {
    Day = 'day',
    Week = 'week',
    Month = 'month',
    Year = 'year'
}
/**
* @export
* @enum {string}
*/
export enum ReadOnlyMaintenanceTaskStateEnum {
    Overdue = 'overdue',
    Duesoon = 'duesoon',
    Active = 'active',
    Done = 'done'
}


